import { Avatar, AvatarFallback } from '@workspace/ui/components/avatar'
import { Badge } from '@workspace/ui/components/badge'
import { cn } from '@workspace/ui/lib/utils'
import { ACTIVITY_ICONS, ACTIVITY_LABELS } from '../icons'
import type { ActivityEntry } from '../types'

export function ActivityRow({ entry }: { entry: ActivityEntry }) {
  const { icon: Icon, color } = ACTIVITY_ICONS[entry.type]

  return (
    <div className="flex items-start gap-4 px-5 py-3.5">
      <div className="mt-0.5 flex size-8 shrink-0 items-center justify-center rounded-lg bg-card">
        <Icon className={cn('size-3.5', color)} />
      </div>

      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2">
          <Avatar className="size-5">
            <AvatarFallback className="bg-elevated text-[8px] font-medium text-white">
              {entry.actor.initials}
            </AvatarFallback>
          </Avatar>
          <span className="text-xs font-medium text-foreground">{entry.actor.name}</span>
          <Badge variant="secondary" size="sm" className="text-[9px]">
            {ACTIVITY_LABELS[entry.type]}
          </Badge>
        </div>
        <p className="mt-1 text-xs text-muted-foreground">{entry.description}</p>
        {entry.metadata && (
          <p className="mt-0.5 text-[10px] text-muted-foreground/80">{entry.metadata}</p>
        )}
      </div>

      <span className="shrink-0 text-[10px] text-muted-foreground/80">{entry.timestamp}</span>
    </div>
  )
}
